import { CurrencyInputField, SelectDropdownField } from 'components/molecules'
import { FieldArray, Form, Formik } from 'formik'
import { Fragment } from 'react'
import { Button, Table } from 'reactstrap'
import TimeUtil from 'utils/time-util'
import PropTypes from 'prop-types'
import { USERABLE_TYPE } from 'domains/fast-sell-price-offer/constants'
import fastSellPriceOfferFormSchema from './fast-sell-price-offer-form-schema'

const propTypes = {
  onSubmit    : PropTypes.func,
  priceOffers : PropTypes.arrayOf(
    PropTypes.shape({
      price      : PropTypes.number,
      updated_at : PropTypes.string,
      user       : PropTypes.shape({
        user_type: PropTypes.string
      })
    })
  ),
  disabled: PropTypes.bool
}

const defaultProps = {
  onSubmit : () => { },
  disabled : false
}

const FastSellPriceOfferForm = ({
  onSubmit,
  priceOffers,
  disabled
}) => {
  const handleClickAddPriceOffer = (arrayHelpers) => {
    const priceOffer = {
      price : '',
      user  : {
        user_type: ''
      }
    }
    arrayHelpers.push(priceOffer)
  }

  const handleClickRemove = (index, priceOffer, arrayHelpers) => {
    const isNew = !priceOffer.id
    if (isNew) {
      arrayHelpers.remove(index)
      return
    }

    const removedPriceOffer = {
      ...priceOffer,
      destroy: true
    }
    arrayHelpers.replace(index, removedPriceOffer)

  }

  const handleClickUndoDelete = (index, priceOffer, arrayHelpers) => {
    const removedPriceOffer = {
      ...priceOffer,
      destroy: false
    }
    arrayHelpers.replace(index, removedPriceOffer)
  }

  return (
    <Formik
      enableReinitialize={ true }
      initialValues={{ price_offers: priceOffers || [] }}
      validationSchema={ fastSellPriceOfferFormSchema }
      onSubmit={ onSubmit }
    >
      {
        (formik) => (
          <Form>
            <FieldArray name='price_offers'>
              {
                (arrayHelpers) => (
                  <Table
                    borderless
                    size='sm'
                    className='mb-0'
                  >
                    <thead>
                      <tr>
                        <th>Updated At</th>
                        <th>Offer By</th>
                        <th>Price</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        formik.values.price_offers.map((priceOffer, index) => (
                          <Fragment key={ `table-row-price-offer-fields-${index}` }>
                            <tr>
                              {
                                priceOffer.destroy
                                  ? <>
                                    <td colSpan={ 3 }>Delete { priceOffer.user.user_type } offer of { priceOffer.price }</td>
                                    <td className='text-center align-middle text-default'>
                                      <Button
                                        size='sm'
                                        outline
                                        color='default'
                                        onClick={ () => handleClickUndoDelete(index, priceOffer, arrayHelpers) }
                                        disabled={ disabled }
                                      >
                                        <i className='fas fa-undo mr-1' />{ 'Undo' }
                                      </Button>
                                    </td>
                                  </>
                                  : (
                                    <>
                                      <td>
                                        <div>{ TimeUtil.format(priceOffer.updated_at, 'DD MMM YYYY') }</div>
                                        <div>{ TimeUtil.format(priceOffer.updated_at, 'HH:MM') }</div>
                                      </td>
                                      <td>
                                        <SelectDropdownField
                                          formGroupClassName={ 'mb-0' }
                                          name={ `price_offers[${index}].user.user_type` }
                                          getOptionValue={ (option) => option }
                                          getOptionLabel={ (option) => option }
                                          options={ [
                                            USERABLE_TYPE.SELLER,
                                            USERABLE_TYPE.ADMIN
                                          ] }
                                          disabled={ disabled }
                                        />
                                      </td>
                                      <td>
                                        <CurrencyInputField
                                          formGroupClassName={ 'mb-0' }
                                          name={ `price_offers[${index}].price` }
                                          disabled={ disabled }
                                        />
                                      </td>
                                      <td className='text-center align-middle text-danger'>
                                        <Button
                                          size='sm'
                                          outline
                                          color='default'
                                          onClick={ () => handleClickRemove(index, priceOffer, arrayHelpers) }
                                          disabled={ disabled }
                                        >
                                          <i className='fas fa-times-circle fa-lg mr-1' />{ 'Remove' }
                                        </Button>

                                      </td>
                                    </>
                                  )
                              }

                            </tr>
                          </Fragment>
                        ))
                      }
                      <tr>
                        <td
                          colSpan={ 4 }
                          className={ 'text-center' }
                        >
                          <Button
                            outline
                            block
                            color={ 'primary' }
                            size={ 'sm' }
                            onClick={ () => handleClickAddPriceOffer(arrayHelpers) }
                            disabled={ disabled }
                          >
                            { '+ Tambah Price Offer' }
                          </Button>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                )
              }
            </FieldArray>
            <div className='p-3 text-right'>
              <Button
                type='submit'
                color='primary'
                disabled={ disabled }
              >
                { 'Update Price Offers' }
              </Button>
            </div>
          </Form>
        )
      }
    </Formik>
  )
}

FastSellPriceOfferForm.propTypes    = propTypes
FastSellPriceOfferForm.defaultProps = defaultProps
export default FastSellPriceOfferForm
